module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard-container"
  }, [_c('div', {
    staticClass: "main-box"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("欢迎进入后台管理系统")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.1.0@vue-loader/lib/template-compiler?{"id":"data-v-29fc6058"}!./~/_vue-loader@12.1.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/dashboard/index.vue
// module id = 1437
// module chunks = 1